import React, { useState, useEffect, useRef } from "react";
import * as THREE from "three";
import FOG from "vanta/dist/vanta.fog.min"; // Import FOG instead of WAVES

const Background = () => {
  const [vantaEffect, setVantaEffect] = useState(null);
  const vantaRef = useRef(null);

  useEffect(() => {
    window.THREE = THREE;

    if (!vantaEffect && vantaRef.current) {
      setVantaEffect(
        FOG({
          el: vantaRef.current,
          THREE: THREE,
          mouseControls: true,
          touchControls: true,
          minHeight: 200.0,
          minWidth: 200.0,
          /* SOFT ORGANIC COLORS */
          highlightColor: 0x8FB07D, // Your brand light green
          midtoneColor: 0xffffff,    // Pure white transitions
          lowlightColor: 0xf7faf5,   // Very soft off-white green
          baseColor: 0xffffff,       // White base background
          blurFactor: 0.9,           // HIGHER = Softer, blurrier edges
          speed: 2.5,                // Gentle movement
          zoom: 1.0
        })
      );
    }
    return () => { if (vantaEffect) vantaEffect.destroy(); };
  }, [vantaEffect]);

  return (
    <div
      ref={vantaRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: -1,
        background: "#ffffff"
      }}
    />
  );
};

export default Background;
